/**
 * orga app | datentransfer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RolleDetail { 
    mandant_id?: string;
    modified_on_utc?: string;
    titel?: string;
    funktionsbereich_id?: string;
    rolle_id?: string;
    ist_externer_ansprechpartner?: boolean;
    ist_im_dienstplan_verborgen?: boolean;
    ist_im_veranstaltung_home_sichtbar?: boolean;
}

